import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import './InstrumentalSelectCard.scss';

interface IInstrumentalSelectCardProps {
  instrumental: boolean;
  isSelected?: boolean;
  onClick?: (instrumental: boolean) => void;
  disabled?: boolean;
}

const InstrumentalSelectCard = ({
  instrumental,
  isSelected,
  onClick,
  disabled,
}: IInstrumentalSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('instrumental-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(instrumental)}
    >
      <div className="instrumental-select-card-header">
        <div className="instrumental-select-card-header-name">
          {t(`instrumental.${String(instrumental)}.name`)}
        </div>
        <div className="instrumental-select-card-header-description">
          {t(`instrumental.${String(instrumental)}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default InstrumentalSelectCard;
